import APIResponse from "@/types/APIResponse";
import AuthTokens from "@/types/AuthTokens";
import { HttpMethod } from "@/types/HttpMethod";
import { API_BASE_URL } from "@/config/api";

const apiRequest = async <T extends string | boolean | APIResponse<T>>(
  url: string,
  method: HttpMethod,
  data?: any
): Promise<T> => {
  try {
    const headers: HeadersInit = {
      "Content-Type": "application/json",
      accept: "application/json",
    };

    const authToken = getAuthTokenOnClient();
    if (authToken) {
      headers["Authorization"] = `Bearer ${authToken}`;
    }

    const options: RequestInit = {
      method,
      headers,
    };

    if (data) {
      options.body = JSON.stringify(data);
    }

    const endpoint = `${API_BASE_URL}${url}`;
    console.info(`API: [${method}] ${endpoint}`);
    const response = await fetch(endpoint, options);

    if (!response.ok) {
      const error = new Error(
        `Network response was not ok (${response.status}: ${response.statusText})`
      );
      (error as any).response = response;
      throw error;
    }

    // Handling no content
    if (response.status === 204) {
      return true as T;
    }

    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
      return (await response.json()) as T;
    } else {
      return (await response.text()) as T;
    }
  } catch (error) {
    console.error(`Error in ${method} request:`, error);
    throw error; 
  }
};

export const requestToListResources = async <
  T extends string | boolean | APIResponse<T>
>(
  url: string
): Promise<T> => {
  return apiRequest<T>(url, HttpMethod.GET, undefined);
};

export const requestToCreateResource = async <
  T extends string | boolean | APIResponse<T>
>(
  url: string,
  data: any
): Promise<T> => {
  return apiRequest<T>(url, HttpMethod.POST, data);
};

export const requestToUpdateResource = async <
  T extends string | boolean | APIResponse<T>
>(
  url: string,
  data: any
): Promise<T> => {
  return apiRequest<T>(url, HttpMethod.PUT, data);
};

export const requestToDeleteResource = async <
  T extends string | boolean | APIResponse<T>
>(
  url: string
): Promise<T> => {
  return apiRequest<T>(url, HttpMethod.DELETE, undefined);
};

function getCookie(name: string): string | null {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split("=");
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

export const getAuthTokenOnClient = () => {
  const token_access = getCookie("token_access");
  if (token_access) return token_access;
};
